import { useTranslation } from "react-i18next";

export default function AnnouncementsPage() {
  const { t } = useTranslation("sidebar");

  return <title>{`${t("announcements")} - Ximly`}</title>;
}
